module.exports = __webpack_public_path__ + "/img/65b1299fd2d9af52613c594878ac5139.png";